module.exports = __webpack_public_path__ + "img/yn.edf322c7.png";